import { invoiceBillingAddressLines, type InvoiceBillingAddress } from "./invoice-address";

export type BusinessAddress = InvoiceBillingAddress;

export interface DocumentBusinessDetails {
  name: string;
  // Strings exist only in immutable historical snapshots; new saves require fields.
  address: BusinessAddress | string;
  logoDataUrl?: string | null;
  phone?: string | null;
  showPhone?: boolean;
  showAddress?: boolean;
}

export interface BusinessIdentity extends Omit<DocumentBusinessDetails, "address"> {
  website?: string | null;
  address: BusinessAddress;
  version: number;
}

export const emptyBusinessAddress = (): BusinessAddress => ({ country: null, line1: null, line2: null, locality: null, region: null, postalCode: null });

// Address text is composed for display only, never for persistence.
export function businessAddressText(address: BusinessAddress | string): string {
  if (typeof address === "string") return address;
  const country = address.country && /^[A-Z]{2}$/.test(address.country)
    ? new Intl.DisplayNames(["en"], { type: "region" }).of(address.country) ?? address.country : address.country;
  return invoiceBillingAddressLines({ ...address, country }).join("\n");
}

// Missing preferences on historical snapshots preserve their original display.
export function documentBusinessContact(details: DocumentBusinessDetails): string {
  return [details.showAddress !== false ? businessAddressText(details.address) : null,
    details.showPhone && details.phone ? details.phone : null].filter(Boolean).join("\n");
}
